<template>
  <div class="dashboard-container">
    <div class="app-container">试题审核</div>
  </div>
</template>

<script>
export default {
  name: 'QuestionsCheck',
  data() {
    return {}
  }
}
</script>

<style scoped>
</style>
